import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';
import { combineLatest, Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { AppStateService } from '../app-state.service';
import { SvgIconDirective } from '@styleguide/svg-icon/svg-icon.directive';

@Component({
  selector: 'kgr-offline-message',
  templateUrl: './offline-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIconDirective],
})
export class OfflineMessageComponent implements OnInit, OnDestroy {
  @HostBinding('class.kgr-block') _defaultClasses = true;

  showOfflineMessage!: boolean;
  showOnlineMessage!: boolean;

  private connectionStateSubscription!: Subscription;
  private routerSubscription!: Subscription;

  constructor(
    private appStateService: AppStateService,
    private cd: ChangeDetectorRef,
    private router: Router,
  ) {}

  ngOnInit() {
    this.connectionStateSubscription = combineLatest([this.appStateService.isOffline, this.appStateService.isVisible]).subscribe(
      ([isOffline, isVisible]) => {
        this.showOnlineMessage = this.showOfflineMessage && !isOffline;
        this.showOfflineMessage = isOffline && isVisible;
        this.cd.markForCheck();
      },
    );

    this.routerSubscription = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.showOnlineMessage = false;
      this.cd.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.connectionStateSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
  }

  reload() {
    this.appStateService.reload();
  }
}
